import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ResourceName } from '../../generated/fragments';
import { CanEditUserPermissionsPermissionForWorkspace, CanEditUserPermissionsPermissionForProject } from '../../../permissions/queries/generated/fragments';
import { CompleteImages } from '../../../../_global/fragments/generated/CompleteImages';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetResourceQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  id: Types.Scalars['ID']['input'];
}>;


export type GetResourceQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, resource?: { __typename?: 'Account', id: string, memberCount?: number | null, displayName?: string | null } | { __typename?: 'AudioAsset', id: string, memberCount?: number | null } | { __typename?: 'DocumentAsset', id: string, memberCount?: number | null } | { __typename?: 'FileAsset', id: string, memberCount?: number | null } | { __typename?: 'FolderAsset', id: string, memberCount?: number | null, name: string } | { __typename?: 'ImageAsset', id: string, memberCount?: number | null } | { __typename?: 'InteractiveAsset', id: string, memberCount?: number | null } | { __typename?: 'InteractiveLiveAsset', id: string, memberCount?: number | null } | { __typename?: 'ModelAsset', id: string, memberCount?: number | null } | { __typename?: 'Project', private: boolean, rootAssetId: string, id: string, memberCount?: number | null, name: string, projectImages: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, permissions?: { __typename?: 'ProjectPermissions', canEditUserPermissions: boolean } | null } | { __typename?: 'UnsupportedAsset', id: string, memberCount?: number | null } | { __typename?: 'VersionStackAsset', id: string, memberCount?: number | null } | { __typename?: 'VideoAsset', id: string, memberCount?: number | null } | { __typename?: 'Workspace', id: string, memberCount?: number | null, name: string, workspaceImages?: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canEditUserPermissions: boolean } | null } | null } | null };


export const GetResource = /*#__PURE__*/ gql`
    query GetResource($accountId: ID!, $id: ID!) {
  account(by: {id: $accountId}) {
    id
    resource(id: $id) {
      id
      memberCount
      ...ResourceName
      ... on Project {
        private
        ...CanEditUserPermissionsPermissionForProject
        projectImages: images {
          ...CompleteImages
        }
        rootAssetId
      }
      ... on Workspace {
        ...CanEditUserPermissionsPermissionForWorkspace
        workspaceImages: images {
          ...CompleteImages
        }
      }
    }
  }
}
    ${ResourceName}
${CanEditUserPermissionsPermissionForProject}
${CompleteImages}
${CanEditUserPermissionsPermissionForWorkspace}` as unknown as DocumentNode<GetResourceQuery, GetResourceQueryVariables>;

          

          export const useGetResourceQuery = (options?:QueryHookOptions<GetResourceQuery, GetResourceQueryVariables>) => useQuery(GetResource, options);

          

          export type GetResourceQueryOptions = QueryHookOptions<GetResourceQuery, GetResourceQueryVariables>;

          

          export const useGetResourceLazyQuery = (options?:LazyQueryHookOptions<GetResourceQuery, GetResourceQueryVariables>) => useLazyQuery(GetResource, options);

          

          export type GetResourceQueryResult = ReturnType<typeof useGetResourceQuery>;

          
